import { Theme, css } from '@emotion/react';

export const selectFieldFormControl =
  (fullWidth: boolean) =>
  ({ colors, spacing }: Theme) => css`
    width: ${fullWidth ? '100%' : 'auto'};
    margin-top: 0;
    margin-bottom: ${spacing(2)}px;
    .MuiOutlinedInput-notchedOutline {
      border: 1px solid ${colors.borderLight};
    }
  `;

export const selectFieldLabel = ({ colors }: Theme) => css`
  color: ${colors.textLight};

  &.MuiInputLabel-outlined {
    transform: translate(14px, 14px) scale(1); // y => (44-16)/2
  }

  &.MuiInputLabel-shrink {
    color: ${colors.textLight};
    transform: translate(14px, -6px) scale(0.75);
    z-index: 1;
    background-color: ${colors.backgroundLightest};
    padding: 0 4px;
    margin-left: -4px;
  }
`;

export const selectFieldHelperText = ({ spacing }: Theme) => css`
  margin-left: 0;
  margin-top: ${spacing(1)}px;
`;
